import styled from 'styled-components'

export const MilchpreisContainer = styled.div`
  display: flex;
  gap: 20px;
`

export const MilchpreisLeft = styled.div`
  flex: 1;
`

export const MilchpreisRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PriceHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 15px;
`

export const TotalPrice = styled.span`
  font-size: 32px !important;
  font-weight: 500;
  color: #333;
`

export const PriceUnit = styled.span`
  font-size: 14px;
  color: #666;
`

export const BreakdownItem = styled.div<{ isNegative?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 5px 0;
  font-size: 13px;
`

export const BreakdownValue = styled.span<{ isNegative?: boolean }>`
  color: ${props => (props.isNegative ? '#c41e3a' : '#4CAF50')};
  min-width: 50px;
`

export const BreakdownLabel = styled.span`
  color: #666;
  white-space: pre;
`
